import { render, staticRenderFns } from "./productsdemand.vue?vue&type=template&id=8bdefc7a&"
import script from "./productsdemand.vue?vue&type=script&lang=js&"
export * from "./productsdemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports